<template>
    <svg
        viewBox="0 0 21.287 23.236"
        xmlns="http://www.w3.org/2000/svg"
    ><path
        d="M21.287,2.441H17.362V.764H15.124V2.441H6.2V.764H3.959V2.441H0V24H21.287ZM18.8,21.481H2.487v-9.6H18.8Zm0-11.837H2.487V4.961H18.8Z"
        transform="translate(0 -0.764)"
    /></svg>
</template>
